module.exports = __webpack_public_path__ + "media/images/admin/dropzone/error-a6bab8752b253346960382afc90d3b3b.svg";